export const colors = {
  white: {
    500: '#FFFFFF',
  },
  black: {
    500: '#000000',
  },
  primary: {
    50: '#F5FCFA',
    100: '#EBF9F6',
    200: '#EBF9F6',
    300: '#99E0D0',
    400: '#65D0B8',
    500: '#32C0A0',
    600: '#25917B',
    700: '#196257',
    800: '#0C3332',
    900: '#05171D',
  },
  success: {
    100: '#d1fadf',
    500: '#F3565D',
    600: '#027a48',
  },
  error: {
    50: '#FEF7F7',
    100: '#FEEEEF',
    200: '#FCD5D7',
    300: '#F9ABAE',
    400: '#F68086',
    500: '#F3565D',
    600: '#B64149',
    700: '#792D35',
    800: '#3D1617',
    900: '#180C16',
  },
  warning: {
    50: '#FFFCF4',
    100: '#FFF9EA',
    200: '#FEEFCB',
    300: '#FDDF96',
    400: '#FCD062',
    500: '#FBC02D',
    600: '#BC9125',
    700: '#7D621D',
    800: '#3F3316',
    900: '#191711',
  },
  neutral: {
    50: '#F8F9FA',
    100: '#F1F3F4',
    200: '#E4E6EA',
    300: '#DDE0E4',
    400: '#BBC1CA',
    500: '#99A1AF',
    600: '#778295',
    700: '#596273',
    800: '#3B4351',
    900: '#1E2330',
  },
};

export type ColorVariants = keyof typeof colors.primary;
export type ColorTypes = keyof typeof colors;
